export type PageHtmlToolCall = {
  name: string;
  input: {
    file_path?: string;
    content?: string;
    old_string?: string;
    new_string?: string;
    replace_all?: boolean;
  };
};

export function applyPageHtmlTools({
  html,
  toolCalls,
}: {
  html: string;
  toolCalls: PageHtmlToolCall[];
}): string {
  let result = html;
  for (const call of toolCalls) {
    if (call.name === "write_file") {
      if (typeof call.input.content === "string") {
        result = call.input.content;
      }
      continue;
    }

    if (call.name === "replace_string") {
      const oldString = call.input.old_string;
      const newString = call.input.new_string;
      if (typeof oldString !== "string" || typeof newString !== "string") continue;
      if (!oldString) continue;

      if (call.input.replace_all) {
        result = result.split(oldString).join(newString);
      } else {
        const idx = result.indexOf(oldString);
        if (idx === -1) continue;
        result =
          result.slice(0, idx) + newString + result.slice(idx + oldString.length);
      }
    }
  }
  return result;
}
